
import AppBrowse from "@/components/browse/Browse.vue";
import AppScanDifference from "@/components/stock/ScanDifference.vue";
import { StockIn } from "@/models/base";
import { View } from "@/models/view";
import { BrowseService } from "@/services/browse-service";
import { StockService } from "@/services/stock-service";
import { ToolbarService } from "@/services/toolbar-service";
import { IBrowseDataSource } from "@/utils/browse/browse-data-source";
import { FetchedTotal } from "@/utils/views/fetched-total";
import Vue from "vue";
import { UserConfigService } from "../../services/user-config-service";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data() {
		return {
			selectedItems: [] as StockIn[],
			scanStockDifferenceModal: false
		};
	},
	props: {
		browseId: Number,
	},
	computed: {
		dataSource(): IBrowseDataSource<StockIn> {
			let elem = this;
			return {
				getFullElement: async (el:StockIn)=>el,
				getSettings: () => BrowseService.getBrowse(this.browseId),
				async getTotals(view: View): Promise<FetchedTotal[]> {
					return StockService.getTotals(view);
				},
				getElements: StockService.getStock.bind(StockService),
				edit(stock: StockIn) {
					elem.$router.push({path: `/stock/edit`, query: {ids: JSON.stringify([stock.ID])}});
				},
				batchEdit(stocks: StockIn[]) {
					elem.$router.push({path: `/stock/edit`, query: {ids: JSON.stringify(stocks.map(s => s.ID))}});
				},
				async delete(stocks: StockIn[]) {
					await StockService.delStock(stocks);
					return true;
				},
				addRoute: `/stock/new`,
				browseName: "Stock",
				modelName: "StockIn",
				browsePermissions: () => UserConfigService.getPermissionSettings().StockPermissions
			};
		},
		buttonBarItems(): ISelectItem<string>[] {
			return [
				{text: this.$ct("scan.scan-difference").toString(), value: "showStockScanDifference", icon: "barcode"},
			];
		},
	},
	methods: {
		showStockScanDifference(){
			this.scanStockDifferenceModal = true;
		}
	},
	mounted() {
		ToolbarService.title = this.$ct("stock");
	},
	components: {
		AppBrowse,
		AppScanDifference
	},
	i18nEx: {
		componentPrefix: "components.stock"
	},
});
